import React from 'react';
// import { ReactComponent as Back } from '../../assets/icons/Back.svg';
import { ReactComponent as GoToArrow } from '../../assets/svg/ArrowRight.svg';

import NamedLink from '../NamedLink/NamedLink';
import css from './GoToButton.module.css';

function GoToButton(props) {
  const { goToPageName, history } = props;
  return (
    <>
      {/* {goToPageName ? (
        <NamedLink className={css.backBtn} name={goToPageName}>
          <Back className={css.arrowLeft} />
        </NamedLink>
      ) : (
        <button className={css.backBtn} type="button" onClick={() => history.goBack()}>
          <Back className={css.arrowLeft} /> Back
        </button>
      )} */}
      <button className={css.goToBtn} type="button">
        <GoToArrow className={css.arrowRight} />
      </button>
    </>
  );
}

export default GoToButton;
